import { SequenceWaaS } from '@0xsequence/waas'

const sequence = new SequenceWaaS({
    projectAccessKey: 'AQAAAAAAAExvYDEdoUcm7PyuFg6_67Oc3eY',
    waasConfigKey: 'eyJwcm9qZWN0SWQiOjE5NTY3LCJycGNTZXJ2ZXIiOiJodHRwczovL3dhYXMuc2VxdWVuY2UuYXBwIn0=',
    network: 'sepolia'
})

export default sequence;